import { useContext } from 'react'
import AdapterContext from 'src/contexts/AdapterContext'
import 'src/BlockchainAdapter/BlockchainAdapter.types'

const useBlockchainAdapter = (): { [key: string]: any } => {
  const context = useContext(AdapterContext)

  if (!context) {
    throw new Error('useBlockchainAdapter must be used within an AdapterProvider')
  }

  return context
}

export default useBlockchainAdapter
